const country = document.getElementById('country') as HTMLInputElement;
const region = document.getElementById('region') as HTMLSelectElement;
const city = document.getElementById('city') as HTMLInputElement;
const regionLabel = document.querySelector('label[for="region"]');

const setRequired = () => {
  const regionRequired = region.options.length > 1 && city.value;

  if (regionRequired) {
    region.setAttribute('required', '');
    if (regionLabel) {
      regionLabel.textContent = 'Region *';
    }
  } else {
    region.removeAttribute('required');
    if (regionLabel) {
      regionLabel.textContent = 'Region';
    }
  }
};

const observer = new MutationObserver((mutationsList) => {
  for (const mutation of mutationsList) {
    if (mutation.type === 'childList') {
      setRequired();
    }
  }
});
observer.observe(region, { childList: true });
country.addEventListener('change', setRequired);
city.addEventListener('input', setRequired);
